import React from "react";
import { Route, Routes } from "react-router-dom";
import UpdateUser from "../pages/Administration/UpdateUser";
import ChangeUserPassword from "../pages/Administration/ChangeUserPassword";
import NewUser from "../pages/Administration/users/NewUser";
import Suppliers from "../pages/Administration/suppliers/Suppliers";

import EditSupplier from "../pages/Administration/suppliers/EditSupplier";
import CompanyInventory from "../pages/Administration/inventory/CompanyInventory";
import NewDrug from "../pages/Administration/inventory/NewDrug";
import ModifyInventory from "../pages/Administration/ModifyInventory";
import CompanySettings from "../pages/Administration/CompanySettings";
import StaffSchedule from "../pages/users/StaffSchedule";
import NewSupplier from "../pages/Administration/suppliers/NewSupplier";
import SupplierDetail from "../pages/Administration/suppliers/SupplierDetail";
import Branches from "../pages/Administration/branch/Branches";
import NewBranch from "../pages/Administration/branch/NewBranch";
import EditBranch from "../pages/Administration/branch/EditBranch";
import Users from "../pages/Administration/users/Users";
import RoleBasedRoutes from "./RoleBasedRoutes";
import BulkSchedule from "../pages/users/BulkSchedule";
import SMSBundleUsage from "../pages/Administration/SMSBundleUsage";

const AdministrationRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <RoleBasedRoutes
            allowedRoles={["superadmin", "admin"]}
            fallback="/not-found"
          />
        }
      >
        <Route path="/users" element={<Users />} />
        <Route path="/users/:user_id/update" element={<UpdateUser />} />
        <Route
          path="/users/:user_id/change-password"
          element={<ChangeUserPassword />}
        />
        <Route path="/user/create" element={<NewUser />} />
        <Route path="/branches/" element={<Branches />} />
        <Route path="/branches/create" element={<NewBranch />} />
        <Route path="/branches/:branch_id/edit" element={<EditBranch />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/suppliers/create" element={<NewSupplier />} />
        <Route
          path="/supplier/:supplierId/details"
          element={<SupplierDetail />}
        />
        <Route
          path="/suppliers/:supplier_id/update"
          element={<EditSupplier />}
        />
      </Route>
      <Route path="/inventory/" element={<CompanyInventory />} />
      <Route path="/inventory/create" element={<NewDrug />} />
      <Route path="/inventory/:drug_id/modify" element={<ModifyInventory />} />
      <Route path="/company" element={<CompanySettings />} />
      <Route path="/staff-schedule" element={<StaffSchedule />} />
      <Route path="/staff-schedule/bulk" element={<BulkSchedule />} />
      <Route path="/sms-bundle" element={<SMSBundleUsage />} />
    </Routes>
  );
};

export default AdministrationRoutes;
